module.exports = __webpack_public_path__ + "static/img/3.6f64278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/aleksis/3.jpg
// module id = Y0n9
// module chunks = 0